import { jsx, jsxs } from 'react/jsx-runtime';
import { mergeStyleSets, FontSizes, Panel, Stack, Persona, PersonaSize, Link, Text, Icon } from '@fluentui/react';
import { VIEW_ALL_ORDERS_LINK } from './constants.esm.js';
import { sharedClassNames } from '../../styles.esm.js';
import TenantDetails from './TenantDetails/TenantDetails.esm.js';
import { useContext, useCallback } from 'react';
import UserContext from '../../../../context/userContext.esm.js';
import { useTranslation } from 'react-i18next';
import logger from '@agoras/logger';
import { headerContext } from '../../../context.esm.js';
import { useQuery } from '@tanstack/react-query';
import RestClient from '@agoras/rest-client';
import { AppContext } from '../../../../context/context.esm.js';
import { useUserQuery } from '../../../../../hooks/useUserQuery.esm.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var classNames = mergeStyleSets({
    subTitle: {
        fontWeight: 600
    }
});
var personaStyles = {
    primaryText: {
        fontSize: FontSizes.mediumPlus,
        fontWeight: 600
    }
};
var UserPanel = function(param) {
    var isOpen = param.isOpen, dismissPanel = param.dismissPanel;
    var _useContext = useContext(AppContext), signedIn = _useContext.user.signedIn, onLogout = _useContext.onLogout;
    var profileImageUrl = useContext(UserContext).profileImageUrl;
    var _useUserQuery = useUserQuery(), displayName = _useUserQuery.displayName, email = _useUserQuery.email;
    var _useQuery = useQuery({
        queryKey: [
            'user-tenant-details'
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var _response_value, response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            RestClient.AzureManagement.tenants()
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response === null || response === void 0 ? void 0 : (_response_value = response.value) === null || _response_value === void 0 ? void 0 : _response_value[0]
                        ];
                }
            });
        }),
        enabled: signedIn,
        staleTime: Infinity
    }), tenantDetails = _useQuery.data;
    var handleDismiss = useCallback(function() {
        logger.info('', _object_spread({
            action: 'MyAccount',
            actionModifier: 'Close panel'
        }, headerContext));
        dismissPanel();
    }, [
        dismissPanel
    ]);
    var handleSignOut = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    logger.info('', _object_spread({
                        action: 'MyAccount',
                        actionModifier: 'Sign out'
                    }, headerContext));
                    return [
                        4,
                        onLogout === null || onLogout === void 0 ? void 0 : onLogout()
                    ];
                case 1:
                    _state.sent();
                    handleDismiss();
                    return [
                        2
                    ];
            }
        });
    }), [
        handleDismiss,
        onLogout
    ]);
    var t = useTranslation('header').t;
    return /*#__PURE__*/ jsx(Panel, {
        headerText: t('My account'),
        isOpen: isOpen,
        onDismiss: handleDismiss,
        closeButtonAriaLabel: "Close",
        isLightDismiss: true,
        children: /*#__PURE__*/ jsxs(Stack, {
            tokens: {
                childrenGap: 24
            },
            children: [
                /*#__PURE__*/ jsx(Persona, {
                    text: displayName,
                    secondaryText: email,
                    size: PersonaSize.size72,
                    imageUrl: profileImageUrl,
                    hidePersonaDetails: false,
                    imageAlt: displayName,
                    onRenderTertiaryText: function() {
                        return /*#__PURE__*/ jsx(Link, {
                            className: sharedClassNames.link,
                            onClick: handleSignOut,
                            children: t('Sign out')
                        });
                    },
                    styles: personaStyles
                }),
                typeof tenantDetails !== 'undefined' && /*#__PURE__*/ jsx(TenantDetails, {
                    tenantId: tenantDetails.tenantId,
                    displayName: tenantDetails.displayName,
                    defaultDomain: tenantDetails.defaultDomain
                }),
                /*#__PURE__*/ jsxs(Stack, {
                    children: [
                        /*#__PURE__*/ jsx(Text, {
                            variant: "mediumPlus",
                            className: classNames.subTitle,
                            children: t('My orders')
                        }),
                        /*#__PURE__*/ jsxs(Link, {
                            href: VIEW_ALL_ORDERS_LINK,
                            onClick: function() {
                                logger.info(JSON.stringify({
                                    name: 'View all orders in Admin center',
                                    url: VIEW_ALL_ORDERS_LINK
                                }), _object_spread({
                                    action: 'MyAccount',
                                    actionModifier: 'External link'
                                }, headerContext));
                            },
                            target: "_blank",
                            rel: "noreferrer",
                            className: sharedClassNames.link,
                            children: [
                                t('View all orders in Admin center'),
                                /*#__PURE__*/ jsx(Icon, {
                                    iconName: "NavigateExternalInline"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

export { UserPanel as default };
